/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, InputLabel, OutlinedInput, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { LoadingPage } from '../../../../common/LoadingPage';
import { useSelector } from 'react-redux';
import { showNotification } from '../../../../common/Notification/ToastifyNotification';
import { countries, ProviderType } from '../../../../common/const';
import { apiRequest } from '../../../../common/common';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function ProductProvider({
    dialogOpen,
    setDialogOpen,
    productProvider,
    onGridReady,
    fromSupplier,
    providerData
}) {
    const { user } = useSelector((state) => state.users);
    const [dataLoading, setDataLoding] = useState(false);
    const [name, setName] = useState(providerData?.name || null);
    const [country, setCountry] = useState(providerData?.country || null);
    const [address1, setAddress1] = useState(providerData?.address_line_1 || null);
    const [address2, setAddress2] = useState(providerData?.address_line_2 || null);
    const [city, setCity] = useState(providerData?.city || null);
    const [state, setState] = useState(providerData?.state || null);
    const [zipCode, setZipCode] = useState(providerData?.pincode || null);
    const [contactNo, setContactNo] = useState(providerData?.contactno || null);
    const [email, setEmail] = useState(providerData?.email || null);
    const [webSite, setWebSite] = useState(providerData?.website || null);
    const [type, setType] = useState([]);
    const [errors, setErrors] = useState({});

    const handleClose = () => {
        setName('');
        setCountry('');
        setAddress1('');
        setAddress2('');
        setCity('');
        setZipCode('');
        setContactNo('');
        setEmail('');
        setWebSite('');
        setType([]);
        setErrors({});
        if (onGridReady) {
            onGridReady();
        }
        setDialogOpen(false);
    }

    const handleSubmit = async () => {
        const newErrors = {};

        if (!name) {
            newErrors.name = 'Name is required'
        }

        if (type.length === 0) {
            newErrors.type = 'Please select type of provider'
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            setDataLoding(true);
            try {
                let response = null;
                if (providerData) {
                    response = await apiRequest('put', `/product-provider/${providerData?.product_provider_id}`, {
                        name,
                        address_line_1: address1,
                        address_line_2: address2,
                        city: city,
                        state: state,
                        country: country,
                        pincode: zipCode,
                        type: type.toString(),
                        email: email,
                        contactno: contactNo,
                        website: webSite,
                        status: 'active',
                        user_id: user?.user_id,
                        access_level: 'public',
                        organization_id: user?.organization?.organization_id
                    });
                } else {
                    response = await apiRequest('post', '/product-provider', {
                        name,
                        address_line_1: address1,
                        address_line_2: address2,
                        city: city,
                        state: state,
                        country: country,
                        pincode: zipCode,
                        type: type.toString(),
                        email: email,
                        contactno: contactNo,
                        website: webSite,
                        status: 'active',
                        access_level: 'public',
                        user_id: user?.user_id,
                        organization_id: user?.organization?.organization_id
                    });
                }
                if (response?.data) {
                    setDataLoding(false);
                    showNotification('Supplier created successfully', 'success');
                    handleClose();
                }
            } catch (error) {
                setDataLoding(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        }
    }

    useEffect(() => {
        if (providerData) {
            setName(providerData?.name);
            setAddress1(providerData?.address_line_1);
            setAddress2(providerData?.address_line_2);
            setCity(providerData?.city);
            setState(providerData?.state);
            setCountry(providerData?.country);
            setZipCode(providerData?.pincode);
            setContactNo(providerData?.contactno);
            setEmail(providerData?.email);
            setWebSite(providerData?.website);
            setType(providerData?.type);
        }
    }, [providerData]);

    return (
        <Dialog open={dialogOpen} fullWidth maxWidth="md">
            {dataLoading && <LoadingPage isLoading={dataLoading} />}
            <DialogTitle>{providerData ? 'Update' : ''} {fromSupplier ? 'Supplier' : productProvider === 'vender' ? 'Vendor' : 'Manufacturer'}</DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Name *</InputLabel>
                            <OutlinedInput
                                label="Name *"
                                id="standard-adornment-password"
                                type='text'
                                value={name || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.name = ''
                                    } else {
                                        newErrors.name = 'Name is required'
                                    }
                                    setErrors(newErrors);
                                    setName(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.name}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <Autocomplete
                            value={ProviderType.filter((c) => type.includes(c.value)) || null}
                            id="combo-box-demo"
                            size="small"
                            multiple
                            fullWidth
                            clearIcon={null}
                            options={ProviderType}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                const newErrors = errors;
                                if (newValue?.length > 0) {
                                    newErrors.type = ''
                                } else {
                                    newErrors.type = 'Please select type of provider'
                                }
                                setErrors(newErrors);
                                setType(newValue?.map((a) => a.value));
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth {...params}
                                    label="Type *"
                                    name="Type"
                                    variant="outlined"
                                />
                            }
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.type}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Address 1</InputLabel>
                            <OutlinedInput
                                label="Address 1"
                                id="standard-adornment-password"
                                type='text'
                                value={address1 || ''}
                                onChange={(e) => {
                                    setAddress1(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Address 2</InputLabel>
                            <OutlinedInput
                                label="Address 2"
                                id="standard-adornment-password"
                                type='text'
                                value={address2 || ''}
                                onChange={(e) => {
                                    setAddress2(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">City</InputLabel>
                            <OutlinedInput
                                label="City"
                                id="standard-adornment-password"
                                type='text'
                                value={city || ''}
                                onChange={(e) => {
                                    setCity(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">State</InputLabel>
                            <OutlinedInput
                                label="State"
                                id="standard-adornment-password"
                                type='text'
                                value={state || ''}
                                onChange={(e) => {
                                    setState(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <Autocomplete
                            value={countries.find((c) => c.code === country?.toUpperCase()) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={countries}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setCountry(newValue?.code);
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Country" name="Country" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Zip Code</InputLabel>
                            <OutlinedInput
                                label="Zip Code"
                                id="standard-adornment-password"
                                type='string'
                                value={zipCode || ''}
                                onChange={(e) => {
                                    setZipCode(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Contact No</InputLabel>
                            <OutlinedInput
                                label="Contact No"
                                id="standard-adornment-password"
                                type='text'
                                value={contactNo || ''}
                                onChange={(e) => {
                                    setContactNo(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Email</InputLabel>
                            <OutlinedInput
                                label="Email"
                                id="standard-adornment-password"
                                type='text'
                                value={email || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (!e.target.value) {
                                        newErrors.email = 'Email is required';
                                    } else if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                                        newErrors.email = 'Email is invalid';
                                    } else {
                                        newErrors.email = '';
                                    }
                                    setErrors(newErrors);
                                    setEmail(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Website</InputLabel>
                            <OutlinedInput
                                label="Website"
                                id="standard-adornment-password"
                                type='text'
                                value={webSite || ''}
                                onChange={(e) => {
                                    setWebSite(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" onClick={() => handleClose()}>
                    Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={() => handleSubmit()}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}